const HSL_PATTERN = /^\s*([\d.]+)\s+([\d.]+)%\s+([\d.]+)%\s*$/;

/** Deep, ink-like version of the city colour used behind the round letter-mark. */
export function deepShadeHsl(primary) {
  const match = HSL_PATTERN.exec(primary || "");
  if (!match) return "215 45% 20%";
  const hue = Number(match[1]);
  const saturation = Math.min(Number(match[2]), 52);
  return `${hue} ${saturation}% 20%`;
}

/**
 * The civic-notice semantic tone (docs/DESIGN_INSTRUCTIONS.md §3: "`info` … derived from the
 * tenant accent"). Mirrors the mobile app's `noticeShadeHex` (packages/core/src/theme/tokens.ts) —
 * same hue, saturation held at 60–80%, lightness at 36% — so a water-supply notice reads as calm
 * and civic rather than as loud as the accent's own promotional tone, and matches between web and
 * mobile for the same tenant.
 */
export function noticeShadeHsl(accent) {
  const match = HSL_PATTERN.exec(accent || "");
  if (!match) return "31 80% 36%";
  const hue = Number(match[1]);
  const saturation = Math.min(Math.max(Number(match[2]), 60), 80);
  return `${hue} ${saturation}% 36%`;
}

export const BRAND_CREAM = "#f7f3ec";

export function applyTenantTheme(theme) {
  const root = document.documentElement;
  const colors = theme?.colors || {};
  if (colors.primary) root.style.setProperty("--primary", colors.primary);
  if (colors.accent) root.style.setProperty("--accent", colors.accent);
  if (colors.primary) root.style.setProperty("--ring", colors.primary);
  root.style.setProperty("--brand-deep", deepShadeHsl(colors.primary));
  root.style.setProperty("--brand-cream", BRAND_CREAM);
  root.style.setProperty("--info", noticeShadeHsl(colors.accent));
}

export function localized(lang, record, field) {
  if (!record) return "";
  if (lang === "hi") return record[`${field}_hi`] || record[field] || "";
  return record[field] || record[`${field}_hi`] || "";
}
